import { FieldError } from 'react-hook-form'

export const getCombinedErrorMessages = (fieldError: FieldError | undefined): string => {
  const messages: string[] = []

  function extractMessages(error: FieldError | undefined): void {
    if (!error) {
      return
    }

    if (typeof error.message === 'string' && error.message.trim() !== '') {
      messages.push(error.message)
    }

    if (typeof error === 'object') {
      for (const key in error) {
        if (Object.prototype.hasOwnProperty.call(error, key)) {
          extractMessages((error as unknown as Record<string, FieldError>)[key])
        }
      }
    }
  }

  extractMessages(fieldError)
  // Optionally, remove duplicates:
  const uniqueMessages = Array.from(new Set(messages))
  return uniqueMessages.join(', ')
}
